import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/payroll-management-system/automated-salary-calculation/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "automated-salary-calculation" entry is kept); the seo block below is a fallback.

export const automatedSalaryCalculation: ContentPage = {
  slug: "payroll-management-system/automated-salary-calculation",
  template: "hrmsFeature",
  seo: {
    title: "Automate Payroll with Precision and Ease",
    description: "Simplify payroll management with automated salary calculations, customized pay rules, and error-checking algorithms. Accurate payroll processing guaranteed.",
    keywords: [
      "automated payroll",
      "salary calculation software",
      "payroll processing automation",
      "employee payroll system",
      "accurate payroll management.",
    ],
    ogImage: "/assets/data/seoimages/automated-salary-calculation.webp",
  },
  leaf: {
    hero: {
      caption: "Automated Salary Calculation",
      title: "Simplify Payroll with Automated Salary Calculations",
      description: "Ensure accurate and timely salary disbursement with our advanced automated salary calculation system tailored for diverse workforce needs.",
      h1: "caption",
    },
    split: {
      title: "Streamline Payroll Accuracy",
      bullets: [
        { title: "Integration with Attendance", description: "Link attendance records directly to salary calculations with real-time updates." },
        { title: "Customizable Pay Rules", description: "Adapt payroll to unique company policies and various structures." },
        { title: "Error Checking Algorithms", description: "Reduce payroll discrepancies with alerts and corrections for input errors." },
        { title: "Compliance Management", description: "Ensure adherence to labor laws and tax regulations with automated compliance checks." },
      ],
      image: "/assets/images/img/product/hrms/payrollms/automated-salary-calculation_info.webp",
      imageAlt: "automated-salary-calculation_info",
    },
    cardsHeading: {
      title: "Key Features of Payroll Management System",
      description: "Optimize Payroll management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Tax and Compliance Management",
        href: "/hrms-software/payroll-management-system/tax-and-compliance-management",
        description: "Manage your payroll taxes and regulatory compliance effortlessly with our comprehensive tax management system.",
        image: "/assets/images/img/product/hrms/payrollms/tax-and-compliance-management_imge.webp",
        imageAlt: "tax-and-compliance-management",
      },
      {
        title: "Custom Deductions",
        href: "/hrms-software/payroll-management-system/custom-deductions",
        description: "Tailor deductions for taxes, benefits, and other payroll elements to match your company policies and employee agreements.",
        image: "/assets/images/img/product/hrms/payrollms/custom-deductions.webp",
        imageAlt: "custom-deductions",
      },
      {
        title: "Overtime and Leave Calculations",
        href: "/hrms-software/payroll-management-system/overtime-leave-calculations",
        description: "Streamline how you handle overtime pay and leave deductions, ensuring fairness and compliance in your payroll processes.",
        image: "/assets/images/img/product/hrms/payrollms/overtime-leave-calculations.webp",
        imageAlt: "overtime-leave-calculations",
      },
      {
        title: "Payslip Generation",
        href: "/hrms-software/payroll-management-system/payslip-generation",
        description: "Provide clear and detailed payslips automatically each payroll cycle, enhancing transparency and trust with your employees.",
        image: "/assets/images/img/product/hrms/payrollms/payslip-generation_image.webp",
        imageAlt: "payslip-generation",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Optimize Your Payroll Management Now!",
    relatedBlogs: "both",
    relatedBlogsKeyword: "why-automate-payroll",
    metaKey: "automated-salary-calculation",
  },
  sections: [],
};
